<template>
  <v-card>
    <div class="d-flex flex-no-wrap">
      <v-avatar
        class="ma-3"
        size="125"
        tile
      >
        <v-img src="@/assets/images/user.jpeg"></v-img>
      </v-avatar>

      <div class="flex-grow-1 px-2">
        <div class="title-bar d-flex justify-space-between">
          <div>
            <div class="title">
              {{title}}
            </div>
            <div class="subtitle">
              {{user.user_type_name}}
            </div>
          </div>
          <div v-if="!disabled">
            <ButtonActionEdit @click="$emit('edit')" />
            <ButtonActionDelete @click="$emit('delete')" />
            <ButtonActionResetPass @click="$emit('resetPass')" />
          </div>
        </div>
        <v-card-text>
          <v-row>
            <div class="user-card-label">
              Pin koda
            </div>
            <div class="user-card-value">
              {{user.plain_pin_code}}
            </div>
          </v-row>
          <v-row>
            <div class="user-card-label">
              Uporabniško ime
            </div>
            <div class="user-card-value">
              {{user.username}}
            </div>
          </v-row>
          <v-row>
            <div class="user-card-label">
              Ime in priimek
            </div>
            <div class="user-card-value">
              {{user.complete_name}}
            </div>
          </v-row>
          <v-row>
            <div class="user-card-label">
              Davčna št.
            </div>
            <div class="user-card-value">
              {{user.tax_number}}
            </div>
          </v-row>
          <v-row>
            <div class="user-card-label">
              Ulica
            </div>
            <div class="user-card-value">
              {{user.address}}
            </div>
          </v-row>
          <v-row>
            <div class="user-card-label">
              Mesto
            </div>
            <div class="user-card-value">
              {{cityString}}
            </div>
          </v-row>
          <v-row>
            <div class="user-card-label">
              Telefon
            </div>
            <div class="user-card-value">
              {{user.phone}}
            </div>
          </v-row>
        </v-card-text>
      </div>
    </div>
  </v-card>
</template>

<script>
import ButtonActionEdit from './ButtonActionEdit'
import ButtonActionDelete from './ButtonActionDelete'
import ButtonActionResetPass from './ButtonActionResetPass'

export default {
  components: {
    ButtonActionEdit,
    ButtonActionDelete,
    ButtonActionResetPass
  },
  props: {
    user: {
      required: true,
      type: Object
    },
    disabled: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    title () {
      if (this.user.moniker) return this.user.moniker
      if (this.user.username) return this.user.username
      if (this.user.complete_name) return this.user.complete_name
      return ''
    },
    cityString () {
      if (this.user.post_code && this.user.city) return `${this.user.post_code}, ${this.user.city}`
      if (this.user.city) return this.user.city
      if (this.user.post_code) return this.user.post_code
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .v-card {
    padding: 20px;
  }
  .title-bar {
    padding: 10px;
    padding-bottom: 20px;
    box-shadow: 0 4px 3px -5px #455A64;

    .title {
      font-size: 22px;
      font-weight: bold;
      color: #607D8B;
    }
    .subtitle {
      color: #B0BEC5;
      font-size: 12px;
    }
  }
  .v-card__text {
    .col {
      padding: 6px 12px;
    }
    .user-card-label {
      min-width: 120px;
      color: #BDBDBD;
    }
    .user-card-value {
      color: #607D8B;
      font-weight: bold;
    }
  }
</style>
